const Bill_new = () => {
  return (
    <div>
      <h2>지출 신규 등록</h2>
    </div>
  );
};

export default Bill_new;
